var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeeklyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36146",
    "data-name": "Gruppe 36146",
    transform: "translate(-702.83 -3690.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(702.83 3690.77)",
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-bubbles",
    "data-name": "Icon metro-bubbles",
    d: "M23.893,22.8a2.288,2.288,0,0,0,1.254,2.042v.312a4.666,4.666,0,0,1-4.022-1.412,6.3,6.3,0,0,1-1.622.211c-3.117,0-5.644-2.246-5.644-5.017s2.527-5.017,5.644-5.017,5.644,2.246,5.644,5.017a4.628,4.628,0,0,1-1.046,2.91,2.276,2.276,0,0,0-.209.954ZM12.605,5.143c5.457,0,9.9,3.54,10.031,7.947a7.69,7.69,0,0,0-3.132-.657,7.468,7.468,0,0,0-4.98,1.846,6.191,6.191,0,0,0-2.153,4.661,6.013,6.013,0,0,0,.544,2.5c-.1,0-.205,0-.308,0a12.392,12.392,0,0,1-1.564-.1c-2.155,2.155-4.728,2.542-7.215,2.6V23.42a3.992,3.992,0,0,0,2.508-3.226,3.785,3.785,0,0,0-.042-.562A7.675,7.675,0,0,1,2.571,13.3c0-4.5,4.492-8.152,10.034-8.152Z",
    transform: "translate(710.971 3697.598)",
    fill: "#1c9d87"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyIcon);
export default __webpack_public_path__ + "static/media/weeklyIcon.0061f38852666aea03254eac2288e54d.svg";
export { ForwardRef as ReactComponent };